import { VMModule, VMModulesResponse, VMModulesContentResponse } from "../vm_models";

export class VMModulesMapper {
  /* get clean modules */
  public static map(modules: VMModulesResponse) : VMModule[] {
    return modules.modules;
  }

  /* get the content of the passed module and map it to VMModule */
  public static mapContent(module: VMModulesContentResponse) : VMModule {
    let vmModule = new VMModule;

    vmModule.id = module.module.id;
    vmModule.key = module.module.key;
    vmModule.naam = module.module.naam;
    vmModule.status = '';
    vmModule.vragen = module.module.vragen;
    vmModule.maximumScore = module.module.maximumScore;

    return vmModule;
  }

  /* get the keys */
  public static mapKeys(modules: VMModulesResponse) : Array<string> {
    let vmModuleResponse = new Array<string>;

    modules.modules.forEach((item) => {
      vmModuleResponse.push(item.key);
    })

    return vmModuleResponse;
  }
}